module.exports = __webpack_public_path__ + "static/media/repeat-alt.bae3144a.svg";